<template>
  <div v-if="Seleccionado">
    <div v-if="Seleccionado.fecha_alta <= hoy && Seleccionado.id_plan !== 3 ">
      <h1>Credencial</h1>
      <div
        v-if="Seleccionado.id_convenio_prestacional != 96 || hoy < '2026-04-01'"
        class="d-credencial headeryfooter"
        ref="capture"
      >
        <v-row dense style="align-items: center">
          <v-col cols="8">
            <v-img src="@/assets/logo-credencial.png" max-width="250" />
          </v-col>
        </v-row>
        <v-row style="align-items: end;">
          <v-col cols="8">
            <v-row>
              <v-col cols="12">
                <div>{{ Seleccionado.apellido_y_nombre.toLowerCase() }}</div>
                <div class="d-subtitulo">
                  {{ plan.toLowerCase() }}
                </div>
              </v-col>
              <v-col cols="6">
                <div class="d-subtitulo">
                  Nro.Afiliado
                </div>
                <div>{{ Seleccionado.nro_afi }}/{{ Seleccionado.parent }}</div>
              </v-col>
              <v-col cols="6">
                <div class="d-subtitulo">
                  DNI
                </div>
                <div>{{ Seleccionado.nro_doc }}</div>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="4"
            style="display: flex; flex-direction: column; gap: 8px;"
          >
            <div class="d-qr1">
              <qr-code
                class="d-qrcode"
                :text="qrlink"
                color="#065982"
                bg-color="#ffffff"
                :size="100"
                error-level="H"
              >
              </qr-code>
            </div>
          </v-col>
        </v-row>
      </div>

      <!-- OSPICAL -->
      <div
        v-if="Seleccionado.id_convenio_prestacional == 96 && hoy >= '2026-04-01'"
        class="d-credencial headeryfooter ospical"
        ref="capture"
      >
        <v-row dense style="align-items: center">
          <v-col cols="8">
            <v-img src="@/assets/ospical-logo.png" max-width="200" />
          </v-col>
        </v-row>
        <v-row style="align-items: end;">
          <v-col cols="8">
            <v-row>
              <v-col cols="12">
                <div class="d-subtituloospical2">
                  Nro.Ospical: {{ nroOspical }}
                </div>
                <div>{{ Seleccionado.apellido_y_nombre.toLowerCase() }}</div>
                <div class="d-subtituloospical">
                  {{ plan.toLowerCase() }}
                </div>
              </v-col>
              <v-col cols="6">
                <div class="d-subtituloospical">
                  Nro.Afiliado
                </div>
                <div>{{ Seleccionado.nro_afi }}/{{ Seleccionado.parent }}</div>
              </v-col>
              <v-col cols="6">
                <div class="d-subtituloospical">
                  DNI
                </div>
                <div>{{ Seleccionado.nro_doc }}</div>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="4"
            style="display: flex; flex-direction: column; gap: 8px;"
            class="ospicalqr"
          >
            <div class="d-qr1">
              <qr-code
                class="d-qrcode"
                :text="qrlink"
                color="#065982"
                bg-color="#ffffff"
                :size="100"
                error-level="H"
              >
              </qr-code>
            </div>
            <v-img
              src="@/assets/logo-credencial.png"
              max-width="100"
            />
          </v-col>
        </v-row>
      </div>

      <v-btn @click="descargar" color="primary" class="mt-5">descargar</v-btn>
    </div>
    <div v-if="Seleccionado.fecha_alta <= hoy && Seleccionado.id_plan == 3">
      <h1>Afiliado Tercerizado</h1>
    </div>
    <div v-if="Seleccionado.fecha_alta > hoy">
      <strong>El beneficiario todavia no se encuentra de alta</strong>
    </div>
  </div>
</template>


<script>
import { mapActions, mapState } from 'vuex'
import domtoimage from 'dom-to-image-more'
import API from '../../../lib/API'
import LUM from '../../../lib/LUM'

const AFILIACIONES_URL = process.env.VUE_APP_AFILIACIONES_URL

export default {
  data() {
    return {
      nroOspical: null
    };
  },
  watch: {
    Seleccionado: {
      immediate: true,
      async handler(val) {
        this.nroOspical = null;
        if (val && val.id_convenio_prestacional == 96) {
          const result = await API.padron_ospical.traerPorDNI(val.nro_doc);
          console.log("Resultado de padron_ospical:", result);
          if (result && result.nben !== undefined) {
            this.nroOspical = result.nben;
          }
        }
      }
    }
  },
  computed: {
    ...mapState('beneficiarios', ['Titular', 'GrupoFamiliar', 'Seleccionado']),
    ...mapState('autogestion', ['Usuario']),
    ...mapState('planes', ['Lista']),
    hoy() {
      return LUM.datetoYYYYMMDD(new Date())
    },
    qrlink() {
      return `${AFILIACIONES_URL}#/Beneficiarios/check/${this.Seleccionado.id_afiliado}`
    },
    plan() {
      let plan = this.Lista.find((p) => p.id_plan == this.Seleccionado.id_plan)
      return plan.Descripcion_plan || 'Sin plan'
    }
  },
  methods: {
    ...mapActions('autogestion', ['inicializar']),
    ...mapActions('beneficiarios', ['select', 'modificarBeneficiario']),
    descargar() {
      const capture = this.$refs.capture
      let select = this.Seleccionado
      domtoimage.toJpeg(capture).then(function (dataUrl) {
        var link = document.createElement('a')
        link.download = 'credencial_' + select.nro_doc + '.jpeg'
        link.href = dataUrl
        link.click()
      })
    }
  },
  async mounted() {
    if (!this.Usuario) {
      await this.inicializar()
      if (!this.Usuario) {
        this.$router.push({ name: 'Autogestion' })
      }
    }
    if (this.Usuario && this.Seleccionado == undefined) {
      let ben = await API.Beneficiarios.traerUno(this.Usuario.UserId)
      this.select(ben)
    }
  }
}
</script>

<style>
@font-face {
  font-family: 'Cabin';
  src: url('~@/assets/fonts/Cabin_Condensed-Regular.ttf') format('truetype');
}
@font-face {
  font-family: 'Oxygen';
  src: url('~@/assets/fonts/Oxygen-Regular.ttf') format('truetype');
}

.d-credencial {
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 400px;
  /* min-width: 450px; */
  max-height: 275px;
  border: 1px solid black;
  border-radius: 10px;
  font-family: 'Oxygen';
  /* font-size: 1.5em; */
  font-weight: bold;
  color: #fff;
  background-image: url('~@/assets/bg-Credencial.png');
  background-size: cover;
}

.ospical {
  color: #ffffff;
} 
.ospicalqr {
  margin-top: -20px;
}

div {
  text-transform: capitalize;
}

img {
  width: 100%;
  height: 100%;
}

.d-logo {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  max-height: 100px;
  max-width: 250px;
}
.d-qr {
  flex: 1;
}
.d-qr1 {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
}

.d-qrcode {
  background-color: white;
  padding: 5px;
  border-radius: 5px;
}
.d-datos {
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
}

.d-lineadatos {
  display: flex;
  flex-direction: row;
  /* gap: 20px; */
  justify-content: space-between;
  align-items: flex-end;
}
.d-subtitulo {
  color: #010e14;
  padding: 8px 0 8px 0;
  line-height: 0;
  font-family: cabin;
  font-size: 24px;
  font-weight: 100;
  color: #71cdf4;
}

.d-subtituloospical{
  color: #010e14;
  padding: 8px 0 8px 0;
  line-height: 0;
  font-family: cabin;
  font-size: 24px;
  font-weight: 100;
  color: #ffffff;
}


</style>
